import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface StallData {
  so_id: any;
  data: any;
}

export interface MyStallData {
  srNo?: number;
  so_id: string;
  stall_num: string;
  company_name: string;
  website: string;
  youtube?: string;
  facebook?: string;
  instagram?: string;
  action?: any;
  total_requests?: number;
  pendingRedeem?: number;
}

@Component({
  selector: 'app-mystall',
  templateUrl: './mystall.component.html',
  styleUrls: ['./mystall.component.scss']
})
export class MystallComponent {
  displayedColumns: string[] = [
    'so_id',
    'stall_num',
    'company_name',
    'website',
    'category',
    'product',
    'inquiry',
    'total_requests',
    'users',
    'action',
  ];

  stalls: MyStallData[] = [];
  filteredStalls: MyStallData[] = [];
  stall_result: any;

  private destoryRef = inject(DestroyRef);
  user_id: any;
  owner: any;

  constructor(
    private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.user_id = sessionStorage.getItem('User_ID');
    this.GetMyStall(this.user_id);
  }

  AddStallOwner(so_id: any) {
    const dialogRef = this.dialog.open(add_edit_mystall, {
      data: {
        so_id: so_id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.GetMyStall(this.user_id);
    });

  }

  applyFilter(event: Event): void {

    const value = (event.target as HTMLInputElement)
      .value
      .trim()
      .toLowerCase();

    if (!value) {
      this.filteredStalls = [...this.stalls];
      return;
    }

    this.filteredStalls = this.stalls.filter(stall =>
      stall.stall_num?.toLowerCase().includes(value) ||
      stall.company_name?.toLowerCase().includes(value) ||
      stall.website?.toLowerCase().includes(value)
    );
  }

  GetMyStall(user_id: any): void {

    this.spinner.show();

    this.service
      .get_my_stall(user_id)
      .pipe(
        takeUntilDestroyed(this.destoryRef),
        finalize(() => this.spinner.hide())
      )
      .subscribe({

        next: (response: any) => {

          this.stalls = (response.data || []).map(
            (item: any, index: number) => ({
              srNo: index + 1,
              so_id: item.so_id,
              stall_num: item.stall_num,
              total_requests: item.total_requests,
              company_name: item.company_name,
              website: item.website,
              youtube: item.youtube,
              facebook: item.facebook,
              instagram: item.instagram,
              action: item.event_id,

              // Replace with API value later
              pendingRedeem: item.pending_redeem || 0
            })
          );

          this.filteredStalls = [...this.stalls];
        },

        error: (err) => {
          console.error(err);
          this.toastr.error('Failed to load stalls');
        }
      });
  }
  scanReport(so_id: any) {
    this.router.navigate(['admin/Stall Scan/' + so_id]);
  }

  goToCategory(so_id: any) {
    sessionStorage.setItem('so_id', so_id);
    this.router.navigate(['admin/Category/' + so_id]);
  }

  goToProduct(so_id: any) {
    sessionStorage.setItem('so_id', so_id);
    this.router.navigate(['admin/Products/' + so_id]);
  }

  goToInquiry(so_id: any) {
    sessionStorage.setItem('so_id', so_id);
    this.router.navigate(['admin/catinquiry/' + so_id]);
  }

  editMyStall(so_id: any) {
    this.router.navigate(['admin/Edit Stall/' + so_id]);
  }

  createEventStall() {
    this.router.navigate(['admin/My Stall/CreateEventStall/']);
  }

  openStallUsers(so_id: any) {
    this.router.navigate(['/admin/stallsusers/' + so_id]);
  }

  goToRedeemRequests(so_id: any) {
    this.router.navigate(['/admin/redeemrequests/' + so_id]);
  }

  openLink(so_id: any) {
    // const url = `https://aieventzo.com/product_catalogue.html?so_id=${so_id}`;
    // window.open(url, '_blank'); // Opens the link in a new tab

    const currentUrl = window.location.href;

    // Assuming you have an `owner` object in your component
    const storeName = (this.owner && this.owner.company_name)
      ? this.owner.company_name
      : 'our store';

    const message = `🛍️ Check out this product catalogue from ${storeName}:\n${currentUrl}`;

    if (navigator.share) {
      navigator.share({
        title: storeName,
        text: message,
        url: currentUrl
      }).catch((err) => {
        console.warn('Share cancelled or failed:', err);
      });
    } else {

      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }
  }
}


@Component({
  selector: 'add_edit_mystall',
  templateUrl: './add_edit_mystall.html',
  styleUrls: ['./mystall.component.scss'],
  standalone: false
})
export class add_edit_mystall {

  StallForm: FormGroup;
  so_id: any
  result: any;
  private destoryRef = inject(DestroyRef);
  owner_data: any;
  event_id: any;
  stall_id: any;
  selectedStall_id: any;
  owner_name: any;
  owner_number: any;
  company_name: any;
  website: any;
  youtube: any;
  facebook: any;
  instagram: any;
  notes: any;
  stall_num: any;
  id: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;


  constructor(
    private router: Router,
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_mystall>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: StallData
  ) {
    this.so_id = data['so_id'];
    this.StallForm = this.member.group({
      so_id: this.so_id,
      stall_num: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      stall_id: new FormControl(''),
      image_name: new FormControl(''),
      owner_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      owner_number: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      company_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      website: new FormControl(''),
      youtube: new FormControl(''),
      facebook: new FormControl(''),
      instagram: new FormControl(''),
      notes: new FormControl('')
    });

  }

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  options: { stall_num: string, id: any }[] = [];
  filteredOptions: { stall_num: string, id: any }[] = [];

  filter() {
    const filterValue = this.input.nativeElement.value.toLowerCase();

    this.filteredOptions = this.options.filter(option =>
      option.stall_num.toLowerCase().includes(filterValue)
    );
  }


  get_available_stall() {
    this.service.get_available_stall().pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        this.options = data.data.map((item: { stall_num: string; id: number }) => ({
          stall_num: item.stall_num,
          id: item.id
        }));
        // this.stall_num = this.options.find(option => option.id === this.id)?.stall_num || '';
      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );
  }

  ngOnInit(): void {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.get_stall_owner_by_id(this.so_id);
    this.get_available_stall();
  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/stall").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.StallForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }

  get_stall_owner_by_id(so_id: any) {
    this.service.get_stall_owner_by_id(so_id).subscribe(
      (data: any) => {
        this.owner_data = data.data;
        this.so_id = this.owner_data[0].so_id;
        this.stall_id = this.owner_data[0].stall_id;
        this.stall_num = this.owner_data[0].stall_num;
        this.owner_name = this.owner_data[0].owner_name;
        this.owner_number = this.owner_data[0].owner_number;
        this.company_name = this.owner_data[0].company_name;
        this.website = this.owner_data[0].website;
        this.youtube = this.owner_data[0].youtube;
        this.facebook = this.owner_data[0].facebook;
        this.instagram = this.owner_data[0].instagram;
        this.notes = this.owner_data[0].notes;
        this.image_name = this.owner_data[0].image_name;
      });

    this.isOld1 = true;
  }

  onFormSubmit() {

    const formData = this.StallForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.StallForm.valid && hasNonEmptyField) {

      const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;

      this.StallForm.patchValue({
        stall_id: this.selectedStall_id ? this.selectedStall_id : this.stall_id,
        image_name: ExistedImage,
      })

      if (this.so_id) {
        this.service.edit_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Stall Owner Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Stall Owner Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}